import _extends from "@babel/runtime/helpers/extends";
import { EventsRepeaterBase } from './events-repeater-base';
import { GuestInputWUT } from '../../../ui/guest-input/guest-input-wut';
import React from 'react';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
export const EventsRepeaterWUT = props => {
  return /*#__PURE__*/React.createElement(EventsRepeaterBase, _extends({
    LabelComponent: FieldLabelWUT,
    GuestInputComponent: GuestInputWUT
  }, props));
};
//# sourceMappingURL=events-repeater-wut.js.map